name: Standard
slug: standard
cards:
  - question: Your best friend comes to your house one night intoxicated and informs you that they just hit a pedestrian on a crosswalk and left the scene of the accident. At the same time, the local news reports that the pedestrian was killed. Which of the following would you recommend?
    answers:
      - immediately go to the police station and confess
      - wait until the next morning, then confess to the accident, but say nothing about being intoxicated
      - not report the accident
  - question: It is your second date, and your date has spent a lot of time and money preparing dinner for you. You arrive to discover that the main course is something you just can't stomach. Would you...
    answers:
      - tell your date and offer to buy dinner out
      - not say a thing and eat it
      - eat everything else, but leave the entree untouched on your plate
  - question: When it comes to taking criticism, I am...
    answers:
      - completely objective and receptive
      - pretty receptive
      - somewhat receptive
      - easily offended
  - question: When it comes to popularity, I would say I am...
    answers:
      - the kind of person that almost everyone likes
      - those who take the time to know me like me
      - not one of the most popular people around
      - universally disliked
  - question: You are buying a new car. You could get a 'loaded' model and drive it off for a little more than you wanted to spend. Or you could order a car that's exactly what you want, costs exactly as much as you want to pay, but you'll have to wait for three months to get it. What would you do?
    answers:
      - Take the 'loaded' car
      - Order the car of your dreams
  - question: How many times in the last 12 months have you attended or viewed religious services?
    answers:
      - Less than five times
      - Five to 20 times
      - More than 20 times
  - question: The colors I look best in are...
    answers:
      - bold, bright colors
      - muted colors or earth tones
      - pastels
  - question: If you could live the best years of your adult life in one of the following decades, which would you choose?
    answers:
      - 1920s
      - 1960s
      - 2000s
      - 2040s
  - question: If a pandemic canceled a season of the following professional sports, which would you miss the most?
    answers:
      - Cricket or baseball
      - Football or soccer
      - Basketball
      - I don't watch sports
  - question: I have watched more hours of...
    answers:
      - daytime soap operas
      - local and national news
      - late-night talk shows
      - reality TV
  - question: If one was to look through your wardrobe, one would find most everything...
    answers:
      - in its proper place (clothes on hangers and neatly in drawers)
      - unorganized (clothes loosely on hangers, on the floor, or stuffed in drawers)
  - question: When it comes to making decisions, I am usually...
    answers:
      - quick and decisive
      - slow but sure
      - slow and not so sure
      - incapable
  - question: You intensely dislike the boy that your 17-year-old daughter is dating. What course of action are you likely to take?
    answers:
      - not say a word
      - express your dislike for the young man, but allow your daughter to do as she pleases
      - forbid your daughter to see him
  - question: In high school, most of my energies were devoted to...
    answers:
      - studies
      - sports
      - sex
      - parties
  - question: My idea of a great first date is...
    answers:
      - dinner at a fine (and expensive) restaurant, followed by an off-Broadway musical
      - a weekend in the Bahamas
      - a cheeseburger and bowling
  - question: How often are you affected by common illnesses such as colds, the flu, etc.?
    answers:
      - I must have a great immune system. I am rarely sick.
      - I'm as average as one can get on the 'sick scale'.
      - I'm always sick.
  - question: If a crystal ball told you that one of the following changes was going to occur in your life in the next 12 months, the change that would surprise you the least would be...
    answers:
      - moving to a different state
      - having a new romantic involvement
      - making a major career move
  - question: A large national union is on strike for higher wages and benefits. Workers are picketing your favorite grocery store and asking that no one shop at the store. Your reaction is which of the following?
    answers:
      - You support the striking workers and stay away from the store during the strike.
      - You're ambivalent about the strike, but avoid the store for purely practical reasons.
      - You shop at the store in spite of the strike and the pickets.
  - question: If an accident were to rob you of one of the following abilities, which loss would be the most devastating to you?
    answers:
      - sight
      - use of legs
      - speech
      - use of arms
  - question: You loaned a friend of yours $25 for lunch two weeks ago, and you know that she has forgotten all about the loan. What do you do?
    answers:
      - remind her
      - drop subtle hints
      - forget about it
      - hold a grudge
  - question: Of the following four traits of character, the one I am generally not given enough credit for is...
    answers:
      - my concern for others
      - my intelligence
      - my creativity
      - my humor
  - question: You were recently in an industrial accident in which you lost the upper part of your ring finger just below the nail. The company paid all medical expenses and time off work and is awarding you $45,000 for pain and suffering. If you could relive the day of the accident and prevent it from ever happening, you would...
    answers:
      - choose to prevent it
      - say “Thanks, but no thanks — the $45,000 will be just fine!”
  - question: The person who knows my talents, thoughts, desires and philosophy best is...
    answers:
      - my partner
      - a family member
      - a good friend
      - a psychiatrist, member of the clergy, or other professional
  - question: Let's assume Hindus are right — you will be reincarnated. You have your choice to come back as one of the following. Which would you rather be on your return?
    answers:
      - An eagle
      - A dolphin
      - A dog
      - A lion
  - question: If there were no laws against keeping wild animals in your home, which of the following would you want as a pet?
    answers:
      - A chimpanzee
      - A ferret
      - A boa constrictor
      - An iguana
  - question: My credit cards...
    answers:
      - are fully paid off every month
      - have a balance, but I've got my eye on it
      - are maxed out, or close to it
      - are not something I monitor
  - question: Which beverage are you most likely to order before dinner at a nice restaurant?
    answers:
      - A mixed drink
      - Wine
      - Beer
      - A nonalcoholic beverage
  - question: You have won $50,000 on a TV game show. The game rules allow you to take the money and leave, or bet all of it on the 'Triple Your Money' wheel. You will have a 50/50 chance of going home with either $100,000 or nothing. You would...
    answers:
      - take the $50,000 and call it quits
      - spin the wheel for the $100,000
  - question: The thought of flying on a commercial jet...
    answers:
      - scares the daylights out of me
      - frightens me a little, but I can handle it
      - means nothing to me; I have no fear
  - question: If I were to drop out of sight for a year then return, my friends would be most surprised to see me return as a...
    answers:
      - local political candidate
      - published poet
      - born-again Christian
      - convicted felon
  - question: Your local legislature is considering a law that will decriminalize all drugs in your city. What is your reaction?
    answers:
      - Don't do it. Drugs are harmful.
      - Don't do it. I don't want the feel of the city to change.
      - Allow it.
  - question: If I had a streaming service that offered all of the following, I would spend more time watching...
    answers:
      - music videos and shows
      - sporting events and shows
      - news
      - scripted shows
  - question: Which of the following achievements would be most fulfilling to you?
    answers:
      - Publishing a best-selling novel
      - Winning the Boston Marathon
      - Soloing in a twin engine airplane
      - Owning a successful small business
  - question: Of the following household appliances, I could most easily live without...
    answers:
      - a TV
      - a microwave oven
      - a dishwasher
      - a vacuum
  - question: An anonymous donor gives you a check for five million dollars because your name was pulled from a hat. The donor pays all of the taxes, so it's all yours. How much of this newfound fortune will you give to friends and relatives?
    answers:
      - $200,000 or less
      - Between $200,000 and $500,000
      - More than $500,000
  - question: On social media, I spend the most time looking at and reading posts about...
    answers:
      - news
      - sports
      - fashion
      - pop culture
  - question: When it comes to current events, I would say that I am...
    answers:
      - well-versed
      - aware of most things, but no expert
      - aware of things only in my city and country
      - out of touch
  - question: If you were to wake up one morning and learn that one of these cities had been destroyed, you would be least upset to learn that it was...
    answers:
      - Miami
      - Los Angeles
      - New York
      - Washington D.C.
  - question: Which of the following contributes most to your sense of job satisfaction?
    answers:
      - Flexible hours
      - Interesting work
      - Easy workload
      - Compensation
  - question: Which one of your facial features would be most apt to change?
    answers:
      - Eyes
      - Nose
      - Mouth
      - Chin
  - question: Despite my present situation, my preference is to live in...
    answers:
      - a big city
      - the suburbs
      - a small town
      - the countryside
  - question: When it comes to having time to be alone, I have...
    answers:
      - less than I need
      - more than I need
      - about the right amount
  - question: While walking home from work late one evening, you witness two young men mugging a woman in the alley you're passing. You would...
    answers:
      - immediately get involved in any way you could
      - run for help
      - leave the scene of the crime as quickly as possible
  - question: I spend too much of my time...
    answers:
      - planning for the future
      - living for today
      - thinking about the past
  - question: Which of the following people do you admire the most?
    answers:
      - Malcolm X
      - Princess Diana
      - Barack Obama
      - Pope Francis
  - question: If I could have talked to my parents the day after they named me, I would have said...
    answers:
      - “Are you sure you don't want to give this first name a little more thought?”
      - “Is it too late to modify my last name?”
      - “Nice job.”
  - question: In order for me to be both mentally and physically alert, I need...
    answers:
      - 6 hrs of sleep or fewer
      - 6 - 7 hrs of sleep
      - About 8 hrs of sleep
      - More than 8 hrs of sleep
  - question: Which of the following New Year's Eve resolutions are you most likely to adopt?
    answers:
      - Exercise more
      - Cut back on smoking or drinking
      - Improve my eating habits
      - Get organized
  - question: If you were to get married or remarried, as the case may be, in which of the following settings would you prefer the ceremony?
    answers:
      - At a church
      - At home
      - At the local courthouse or civic building
      - At a friend's house in the country
  - question: In high school, your five closest friends would have voted that you had more potential...
    answers:
      - to graduate in the top 10% of your class
      - to win 'Athlete of the Year'
      - to be dubbed the class clown
      - to be the favorite pupil of your teachers
  - question: In my romantic relationships, I have usually been...
    answers:
      - the person to compromise my lifestyle for my partner's benefit
      - the person to ask that my partner compromise more
      - in pretty equal situations
  - question: If you had to pick an allergy to have for the rest of your life, which would you choose?
    answers:
      - Dogs or cats
      - Hayfever/pollen
      - Nuts
      - Dairy products
  - question: If you were to win a state lottery prize of $150,000/yr for the next 20 years, your lifestyle would...
    answers:
      - change dramatically
      - change in some areas
      - basically stay the same
  - question: At times, people may think that I am too much of a...
    answers:
      - dreamer
      - go-getter
      - worrier
  - question: If one of the following tech giants and their products were to disappear, which would affect you the least?
    answers:
      - Facebook
      - Google
      - Apple
      - Amazon
  - question: If you were disappointed with the manner in which your entree was prepared at a restaurant, what would your response be when the waiter asks, "Is everything okay?"
    answers:
      - “No, this dish is wrong. Can you take care of it?”
      - “Well, this isn't quite what I ordered, but it's fine.”
      - “Yes, thank you.”
  - question: Is it possible that some UFO sightings are really vehicles with extraterrestrial beings?
    answers:
      - Yes
      - No
  - question: There's a new club in town that all of your friends are joining. To join you must perform one of the following feats. Which feat would you be least willing to do?
    answers:
      - Eat a live worm
      - Sing on stage on amateur nights at a local bar
      - Take a solo ride in a hot-air balloon, to a height of 500 feet
      - Crawl through a concrete pipe 150ft long and 3ft wide, that is buried 10ft underground
  - question: What is the age range to which you honestly expect to live?
    answers:
      - 60 or younger
      - Between 60 and 75
      - Between 75 and 90
      - 90 or older
  - question: There's a local government referendum to set speed limits for major roadways. For which of the following local speed limits would you vote?
    answers:
      - 50 mph / 80 kph
      - 60 mph / 95 kph
      - 70 mph / 110 kph
      - No speed limit
  - question: People who check their astrology forecasts are...
    answers:
      - sadly in need of help and common sense
      - fine, as long as they don't take it seriously
      - just trying to be prepared for daily events
  - question: You've won $10,000 on a game show for charity. You get to choose which non-profit organization receives the prize money. Which would you most like to see have the $10,000?
    answers:
      - The Cancer Society
      - Greenpeace
      - The Red Cross
      - The World Health Organization (WHO)
  - question: Given $500,000 for a home, I would prefer...
    answers:
      - a condo in the city
      - a suburban house
      - a country cottage
      - a townhouse near the city limit
  - question: When I first wake up in the morning, I'm usually...
    answers:
      - alert and energized
      - groggy but pleasant
      - grouchy
  - question: I prefer to spend Saturday nights...
    answers:
      - at parties
      - reading a good book
      - watching a movie
      - out to dinner with a friend
  - question: At a summer 'Movie Night in the Park' event, you are selected to choose the movie. Which do you choose?
    answers:
      - Casablanca
      - Star Wars
      - The Wizard of Oz
      - Beverly Hills Cop
  - question: When it comes to my work and play habits, my friends would say that I am...
    answers:
      - work too much
      - play too much
      - find the right balance
  - question: Your elected representatives are about to vote on a constitutional amendment to guarantee illegal immigrants certain rights that citizens enjoy. Which view is closest to your own?
    answers:
      - Illegal immigrants, by circumventing the official system, have not earned the rights of citizens
      - Illegal immigrants should be protected from egregious abuse, but not enjoy most of the rights of citizens
      - There's no need to amend the constitution — what illegal immigrants need is a path to citizenship
      - Illegal immigrants should have the same rights as citizens
  - question: If I could improve my skills in one of the following areas, it would be...
    answers:
      - math
      - reading
      - writing
      - speaking
  - question: The biggest problem with marriage is...
    answers:
      - having to compromise on day-to-day decisions
      - putting up with the other person's idiosyncracies
      - losing the freedom to come and go as I please
  - question: If your friends were to vote on your political philosophy, they would conclude that you...
    answers:
      - tend to have liberal positions
      - tend to have conservative positions
      - are in the center
      - don't really have political opinions
  - question: My threshold for pain is...
    answers:
      - very high
      - average
      - nonexistent
  - question: You have loaned your lawn mower to a neighbor whom you know casually. After it is returned, you discover that it has a broken blade. Would you...
    answers:
      - immediately tell your neighbor and ask that he pay for the repairs
      - casually mention the broken blade to the neighbor a week after
      - never mention the blade, but never loan it to that neighbor again
      - fix it and loan it to him again without mentioning the previously broken blade
  - question: If you were offered the chance to go on a SpaceX ride to the Internation Space Station, you would...
    answers:
      - Accept, no questions asked
      - Tentatively accept, and ask a ton of questions
      - Decline
  - question: On my 30th birthday I was (or think I'm likely to be)...
    answers:
      - depressed
      - not bothered by turning 30
      - happy to be 30
  - question: On my 40th birthday I was (or think I'm likely to be)...
    answers:
      - depressed
      - not bothered by turning 40
      - happy to be 40
  - question: On my 65th birthday I was (or think I'm likely to be)...
    answers:
      - depressed
      - not bothered by turning 65
      - happy to be 65
  - question: My friends would probably say that I would be most successful as a...
    answers:
      - psychiatrist
      - lawyer
      - priest/pastor
      - doctor
  - question: You discover that a one-year employee of yours, who is competent and doing excellent work for the company, lied on his resume about the college he attended and the degree he earned. Do you...
    answers:
      - fire him
      - talk to him about it, but have him remain with the company
      - choose to ignore it
  - question: I would be willing to go to jail for my beliefs/convictions if...
    answers:
      - I knew I'd be bailed out
      - I were arrested with a group, so I wouldn't be alone
      - getting arrested meant more publicity for the cause
      - Nothing is worth going to jail.
  - question: After I get a haircut, people usually...
    answers:
      - spontaneously compliment me
      - stare, then mumble something non-committal
      - laugh
      - don't notice
  - question: Everyone can think of ways their quality of life might be improved. Under my present circumstances, I am...
    answers:
      - very pleased with the scope and direction of my life
      - reasonably content, but would like to see some changes soon
      - mad as hell and not going to take it anymore
  - question: Which of the following has had the most dramatic effect on your psyche?
    answers:
      - The death of a friend or relative
      - The end of an intimate relationship
      - A large financial loss
      - A personal health problem
  - question: Listening to music while on hold is...
    answers:
      - a fate worse than death
      - no big deal — I tune it out
      - pleasant — I hear music I might not otherwise have heard
  - question: If you could go back to your 7th birthday, you would have started...
    answers:
      - tennis lessons
      - piano lessons
      - Spanish lessons
      - studying harder
  - question: Of the following household pests, which would you be most upset to see in your home?
    answers:
      - A cockroach
      - A spider
      - A mouse
      - Weevils
  - question: If your son or daughter received a full academic scholarship to each of the following schools, which would you prefer they attend?
    answers:
      - Stanford University
      - University of Oxford
      - École Polytechnique Fédérale de Lausanne
      - Tsinghua University
  - question: Your family is choosing an epitaph for your gravestone. Which would be the most appropriate?
    answers:
      - There's never enough time.
      - Nice try, no cigar.
      - It's been great — see you soon.
      - Guess I just forgot to pay attention.
  - question: When it comes to being rich and famous, I would prefer to...
    answers:
      - be rich with a famous name and face
      - be rich with a famous name, but go around unrecognized
      - be rich and unknown
      - be in my current situation
  - question: An online university has just unveiled 'virtual reality' classes, taught by famous historical figures. You have the opportunity to enroll. Which would be your first choice?
    answers:
      - ‘On Writing’ by William Shakespeare
      - ‘On Creativity’ by Leonardo da Vinci
      - ‘Understanding People’ by Sigmund Freud
  - question: Given the necessary money, which would be your preference in home decor?
    answers:
      - Urban Collective
      - Relaxed Modern
      - American Colonial
      - Scandinavian Contemporary
  - question: Did you hear the one about... Some people tell jokes well. Some get by. And some should leave the joke telling to others. Which are you?
    answers:
      - I tell a pretty mean joke.
      - I get by.
      - I'm hopeless.
  - question: The vet informs you that your six-year-old dog is very ill, but probably not in a lot of pain. She will die within a month if she does not undergo surgery. If she has surgery, she will probably live a happy, healthy life. Surgery will cost $2,000. Would you...
    answers:
      - go ahead with surgery
      - decline surgery
      - ask that the vet put the dog to sleep
  - question: When having casual discussions with close friends, we spend most of our time discussing...
    answers:
      - ourselves
      - our families
      - current events
      - our jobs
  - question: People seem to run on one of three schedules — early, punctual or late. If you were to meet a friend at 6pm for dinner, you would probably arrive...
    answers:
      - early
      - on time
      - a few minutes late
      - late
  - question: An auctioneer is selling 200 keys, only one of which will fit in the front door of a $375,000 home. The purchaser of the right key gets to keep the house. What is the most you would pay for one of the keys?
    answers:
      - Less than $1,000
      - Between $1,000 and $5,000
      - Between $5,000 and $10,000
      - More than $10,000
  - question: You are on a camping trip. Not having a good place to put your cash, you hide it in a nearby tree. On the last day of your trip, you pack your things, hike a mile to your car, and leave for home. Not until you are 60 miles from the campsite do you remember the cash. The least amount you would go back for is...
    answers:
      - $25
      - $100
      - $500
      - $1,000
  - question: Throughout the course of a year, how many books do you generally read for pleasure?
    answers:
      - 5 or fewer
      - 6 to 10
      - 11 to 20
      - More than 20
  - question: Who do you believe was the most effective leader of their country?
    answers:
      - Barack Obama
      - Angela Merkel
      - Fidel Castro
      - Vladimir Putin
  - question: If you were offered $75,000 to get a permanent tattoo that said 'ELVIS' on your forearm, you would...
    answers:
      - decline
      - accept the money and get the tat
  - question: You are three miles out of Gallup, New Mexico, where you purchased gas, when you discover that the attendant overcharged you by $10. You would...
    answers:
      - drive back to the station to rectify the error
      - continue on and try to call the station to rectify the error
      - regret that it happened, but continue on
      - forget about it in a few minutes
  - question: In sporting events in which you have no particular allegiance to any team or player, you usually root for...
    answers:
      - the underdog
      - the favorite
      - whoever's losing at the moment
      - no one
  - question: After how many drinks in an evening, do you feel you lose your competency?
    answers:
      - 1 to 2
      - 3 to 4
      - 5 to 6
      - I always hold my liquor and know what's going on
  - question: If all of the following foods had no calories, and you could have as much as you wanted at no charge, which would you choose to consume?
    answers:
      - pizza
      - candy
      - cake
      - fish
  - question: When I am unattached and flirting with someone in whom I have a romantic interest, I am...
    answers:
      - generally inept
      - reasonably good at flirting
      - one of the best flirts in the game
  - question: Last New Year's Eve you...
    answers:
      - had no alcohol
      - had a few drinks
      - got drunk
      - got so plastered I don't remember most of it
  - question: If five friends of the opposite sex were rating legs, they would rate mine as...
    answers:
      - above average
      - average
      - poor
  - question: I usually deal with major personal problems by discussing them with...
    answers:
      - anyone who will listen
      - people who are very close
      - no one
  - question: You were told by a reliable source that a good friend has been making slanderous comments about you. You would...
    answers:
      - confront your friend immediately
      - ignore the comments and continue the friendship
      - snub your friend until he or she inquires about your mood change
  - question: Assuming you could clear $500,000 a year at any of these professions, which would you prefer to be?
    answers:
      - Professional athlete
      - Trial lawyer
      - Stand-up comedian
      - Racehorse trainer
  - question: Which of the following gives you the greatest pleasure?
    answers:
      - Shopping
      - Fornicating
      - Eating and drinking
      - Sleeping
  - question: Of the following four feelings, the one that has had the greatest effect on my life is...
    answers:
      - fear
      - love
      - hate
      - empathy
  - question: If your five closest friends were to take a vote concerning your temperament, they would say that you are...
    answers:
      - pleasant
      - even-tempered
      - moody
      - nasty
  - question: If your three closest friends got together and had to pick one of the following traits as your strongest, which trait would they pick?
    answers:
      - Determination
      - Honesty
      - Intelligence
      - Kindness
  - question: When I'm mad at someone, I usually...
    answers:
      - avoid them until I've cooled down
      - avoid them until they apologize
      - sit down as soon as possible so we can talk things out
  - question: At this point in your life, which of the following would raise your level of happiness the most?
    answers:
      - More romance
      - More money
      - Different occupation
  - question: I am more like my...
    answers:
      - mother
      - father
      - aunt
      - uncle
  - question: How familiar are you with the Bible?
    answers:
      - Very
      - Somewhat
      - Barely
  - question: My friends would say that when I argue a point, I...
    answers:
      - tend to exaggerate or bend the truth
      - am too blunt
      - leave out important details
      - get angry easily
  - question: Which of the following acts, if performed by your child in public, would you find least embarrassing?
    answers:
      - picking their nose
      - belching
      - breaking wind
      - using a swear word
  - question: During my childhood, my parents gave me...
    answers:
      - too much attention
      - an appropriate amount of attention
      - too little attention
  - question: When I suffer from a physical ailment that is not readily apparent to those around me, I am the kind of person who...
    answers:
      - suffers in silence
      - lets others know if I need help
      - complains
  - question: There are Theodores who prefer to be called Ted, Elizabeths who prefer Liz and Burton Jameses who go by BJ. Which of the following do you prefer to be called by friends?
    answers:
      - the first name on your birth certificate
      - your initials
      - a shortened version of your name
      - your surname
  - question: When I retire, I would most like to be able to...
    answers:
      - play sports every day
      - travel the world
      - devote my time to charity and helping others
      - just relax
  - question: On a scale of profanity usage, I rate a...
    answers:
      - 0 to 4 (little usage)
      - 5 to 7 (average usage)
      - 8 to 10 (heavy usage)
  - question: As a conversationalist in social settings, people might say that...
    answers:
      - I talk too much
      - I'm too quiet
      - I'm too loud
      - I'm a wonderful conversationalist
  - question: The last book you read to completion was...
    answers:
      - biographical
      - fictional
      - related to my job
      - none of the above
  - question: When driving, I prefer to listen to...
    answers:
      - public radio
      - my music library
      - podcasts
      - audiobooks
  - question: What would your net worth need to be for you to feel wealthy?
    answers:
      - $100,000 or less
      - About $500,000
      - About $2,000,000
      - $10,000,000 or more
  - question: What do you think happens after you die?
    answers:
      - You become worm food
      - Some essence of who you were — for lack of a better word, a 'soul' — lives on
      - You are reincarnated
      - You go to the afterlife
  - question: Administering a painless death, either actively or passively, to end the suffering of someone who is terminally ill, is...
    answers:
      - never justified
      - justified, as long as you get the person's explicit consent at the time
      - justified, as long as you have the consent of their healthcare proxy
      - always justified
  - question: One afternoon on your way home, you spot an injured puppy lying in the road. What would be your immediate reaction?
    answers:
      - Pull over, collect the puppy and drive to the nearest vet or shelter
      - Pull over, and spend 15 minutes looking nearby for the owner
      - Keep driving
      - Run over it to put it out of its misery
  - question: The music I like the least is...
    answers:
      - classical
      - Christmas carols
      - pop hits
      - jazz
  - question: At one time or another, we have probably all been guilty of stealing something — candy, office supplies, hotel toiletries. What's the value of the most expensive item you've taken?
    answers:
      - $20 or less
      - Between $20 and $100
      - $100 or more
  - question: A police checkpoint, set up to check drivers' license and registration, is...
    answers:
      - an effective way of making the roads safe for everyone
      - a way of discriminating against some people in society behind the mask of public safety
      - an unreasonable encroachment on the right to freedom of movement
  - question: Three weeks after you received a $2,200 check from your insurance company to replace the lost stone in your engagement ring, you find the gem under the fridge. Now you have the $2,200 and the gemstone. Which would you do?
    answers:
      - Return the money to the insurance company
      - Keep the money, but feel guilty about spending it
      - Spend the money as soon as possible
      - Not worry about it at all — the insurance company can afford it
  - question: How many children would you ideally like to have?
    answers:
      - None
      - One
      - Two or three
      - Four or more
  - question: If you could go back and change an area of your life, which would you choose to alter?
    answers:
      - Your education
      - Your career
      - Your upbringing
      - Your love life
  - question: According to many educators, there are two types of individuals — left-brain folks who tend to be more ordered, logical and verbal; and right-brain people who are more creative, visual, athletic and artistic. Into which category do you fall?
    answers:
      - Left-brain dominant
      - Right-brain dominant
      - Balanced between left- and right-brain
  - question: How much have you spent on your wardrobe in the past 12 months?
    answers:
      - Almost nothing
      - Less than $500
      - Between $500 and $1,000
      - More than $1,000
  - question: At your high school reunion, you decide to participate in a competitive quiz game. Each member of your 4-person team will answer questions in a different subject area. Which subject do you pick?
    answers:
      - Science
      - Geography
      - History
      - Math
  - question: Your elderly relative dies, and leave you an annuity worth $50,000 a year after taxes. You would probably...
    answers:
      - keep your current job, and invest the money
      - keep your current job, but raise your standard of living
      - quit your job to look for more enjoyable work
      - retire to a life of leisure
  - question: I tend to keep promises more with...
    answers:
      - myself
      - my family
      - my colleagues
  - question: I would least want my young child to have...
    answers:
      - a toy gun
      - a device with a screen
      - comic books
      - anything marketed specifically to their gender
  - question: In large social settings, I am...
    answers:
      - very comfortable
      - comfortable enough to get through it
      - awkward
      - cripplingly shy
  - question: My belief in a supreme being is most closely described as...
    answers:
      - nonexistent
      - a benevolent entity who watches over me
      - a powerful entity, indifferent to my existence
      - a creator whose contribution was to set the universe in motion
  - question: Which is your favorite season?
    answers:
      - Summer
      - Winter
      - Dry
      - Wet
  - question: A mother should work if...
    answers:
      - she chooses to do so
      - she has to, in order to provide for her family
      - her children are beyond their formative years
  - question: From which country of origin do you prefer watching movies and TV shows?
    answers:
      - South Korea
      - United States
      - India
      - United Kingdom
  - question: Meditation is...
    answers:
      - a crock
      - fine, so long as you have the luxury of time
      - for people from specific cultures and backgrounds
      - an essential part of finding well-being
  - question: Which of the following cuisines do you most enjoy?
    answers:
      - Indian
      - Chinese
      - American
      - Italian
  - question: Happiness can best be found by...
    answers:
      - thinking of others
      - trying to please yourself
      - living honestly
      - getting rich
  - question: If a psychic told you that there would be a monumental change in your life within the next two years, which of these psychic predictions would surprise you the most?
    answers:
      - You will have a new love life.
      - You will earn three times the money you're making now.
      - You will have a child.
      - You will live 1,000 miles from your present home.
  - question: A fortune teller tells you that in six months you will have a new best friend. You also learn that your new best friend will have done one of the following. Which would most prompt you to say, “How could I have a best friend like that?” You can only pick one.
    answers:
      - Your new best friend voted for Donald Trump in the 2016 and 2020 US presidential elections
      - Your new best friend married their half-sibling
      - Your new best friend is a Scientologist
  - question: If you could apprentice with one of the following people for a year, who would you select?
    answers:
      - LeBron James
      - Rihanna
      - Alexandria Ocasio-Cortez
      - Deepak Chopra
  - question: Your boss assigns you a project at work. You agree to take it, but later you realize that it requires a lot of after-hours time to complete. Do you...
    answers:
      - tell your boss you just can't finish it in time
      - tell your boss it'll take a lot of extra time, but you don't mind
      - tell your boss it'll take a lot of extra time, and ask for extra pay
      - work the extra time without saying anything
  - question: How often do you brush your teeth?
    answers:
      - Less than once a day
      - Once a day
      - After major meals
      - Four or more times a day
  - question: With how many close friends and family members have you shared a video call in the past 30 days?
    answers:
      - None
      - 1 to 5
      - 6 to 10
      - More than 10
  - question: Adding cable TV, streaming services and video platforms like YouTube, I watch...
    answers:
      - less than 3 hrs each week
      - 3 to 10 hrs each week
      - 10 to 20 hrs each week
      - more than 20 hrs each week
  - question: Which of the following meats would you guess you have most consumed in the last 12 months?
    answers:
      - Beef
      - Chicken, turkey and duck
      - Fish, shrimp, lobster and other seafood
      - I'm a vegetarian
  - question: My reaction to cigarette smoke could best be described as —
    answers:
      - Liking it
      - Putting up with it
      - Asking the smoker to go elsewhere
      - Leaving the room or area
  - question: Capital punishment is...
    answers:
      - never justified
      - justified, if the person has chosen that punishment instead of non-lethal alternatives
      - justified, if they are guilty of the associated crimes
      - sometimes cruel, but a necessary deterrent to maintain law and order
  - question: If you were going to attend a small dinner party with friends, they would anticipate that you would...
    answers:
      - be the life of the party
      - bring a generous gift
      - add smart, thoughtful conversation
      - be quiet and take it all in
  - question: Driving down the highway, you realize you haven't eaten in hours. You pull over at the next rest stop, and see the following eateries. Where do you buy your meal?
    answers:
      - McDonalds
      - Subway
      - Starbucks
      - Pizza Hut
  - question: In an apparent suicide, the police discover that the deceased, who suffered from an incurable and debilitating disease, had enlisted the help of a friend to end their life. If you could make the laws applicable to this situation, you would...
    answers:
      - treat the incident as a suicide, and dismiss the participation of the friend
      - charge the friend with accidental killing, exempt from prosecution
      - charge the friend with voluntary manslaughter
      - create a new legal category for assisted suicide, which exonerates the friend from any wrongdoing
  - question: You're driving out of a national park after a week of camping when a sharp turn spills the contents of your garbage bag across a hundred yards of foliage. What do you do?
    answers:
      - Stop the vehicle, grab another bag and walk through the foliage, retrieving each piece of garbage by hand
      - Drive on, but tell the rangers stationed at the park exit you spotted a lot of litter a few miles back
      - Drive on, and forget about it
  - question: The flaw I would put the least weight on in considering a potential spouse is...
    answers:
      - forgetfulness
      - sloppiness
      - laziness
      - distractedness
  - question: When traveling by car, I wear a seatbelt...
    answers:
      - always
      - if I'm going on the highway
      - when I remember
      - never
  - question: Which best matches your reaction to the 2020 coronavirus pandemic?
    answers:
      - Nothing — it didn't affect me
      - I stocked up on supplies and didn't leave the house unless absolutely necessary
      - I stocked up on supplies, but kept my life and routines as intact as I could
      - I moved to a more remote location to ride it out
  - question: Having lost a coin toss with your spouse, you have to choose a name from your spouse's shortlist. What do you christen your soon-to-be-born daughter?
    answers:
      - Caitlin
      - Anastasia
      - Bo
      - Yvette
  - question: You've been exposed to a powerful neurotoxin and only have a few hours to live. Who do you call first?
    answers:
      - Your partner or best friend
      - Your mother or father
      - Your child
      - I wouldn't want to burden those I love with the knowledge
  - question: If you could sneak away to a far-off location for a week, be one of the following, and come back with no ill effects or disruption to your life, you would choose to be a...
    answers:
      - mercenary
      - missionary
      - heir/heiress to a fortune
      - village elder
  - question: I wish I was...
    answers:
      - smarter
      - more athletic
      - better-looking
      - wealthier
  - question: Which side of labor/management disputes do you usually root for?
    answers:
      - Labor
      - Management
      - It depends on the circumstance
      - Neither — I don't know or care about it
  - question: You work at an Amazon fulfillment center, packing boxes for shipment. You notice that your coworker pockets one or two items a day for himself — nothing too expensive. What do you do?
    answers:
      - Inform your manager
      - Take your coworker aside, and warn him that you know what he's doing
      - Tell your coworker he's giving everyone a bad name, and needs to quit or you'll go to management
      - Start pocketing one or two items a day for yourself
  - question: Despite how I may appear to my friends and others, I consider myself to be...
    answers:
      - gregarious and outgoing
      - open but reserved
      - a loner at heart
  - question: If my friends were asked how good I am at keeping secrets, they would say I am...
    answers:
      - tight-lipped
      - okay
      - a blabbermouth
  - question: Molecular physicists crack the secret of bidirectional time travel — something to do with hadrons and quarks. In any case, you are part of the first group of civilians selected for travel. You will materialize at the exact same point in space, just at a different time. When do you choose to go?
    answers:
      - 1491
      - 1776
      - 1834
      - 1945
  - question: You're forced to make small talk with the person next to you at a dinner fundraiser. Which of the following companions would make it hardest for you to keep the conversation going?
    answers:
      - A sports commentator
      - A venture capital analyst
      - An aide to a congressperson
      - A prison guard
  - question: If you asked my friends about my penchant for gossip, they would say I...
    answers:
      - avoid gossip
      - share juicy tidbits now and then
      - live and die for gossip
  - question: My friends are most likely to trust my judgment in the area of...
    answers:
      - business
      - human nature
      - decor
      - politics
  - question: I usually do most of my Christmas shopping...
    answers:
      - before December
      - a couple weeks in advance
      - at the last minute
  - question: Staying at a motel, you purchase a drink from an outside vending machine. The machine delivers your drink and, surprisingly, spits out a $50 bill. What do you do?
    answers:
      - Take the $50 and return to your room
      - Go to the front desk and tell them they might want to check out the vending machine
      - Buy another drink to see if you can get another $50
      - Leave the $50 there
  - question: What are you most likely to do if someone intentionally steps in front of you at the checkout line in a store?
    answers:
      - Say nothing
      - Passive-aggressively inform them “The line starts back there”
      - Tap them on the shoulder and silently indicate they need to skidaddle
  - question: Given what I perceive as the average happiness level of other people, I would say that I am...
    answers:
      - happier than most people
      - average
      - unhappier than most people
  - question: You are offered two free tickets to a Broadway show you've been dying to see. The problem is that you and your partner ran into old friends last week and accepted a dinner invitation for the same night — tonight. Which of these options are you most likely to exercise?
    answers:
      - Accept the tickets and cancel your plans, saying you're not feeling well
      - Accept the tickets and tell you friends you can't make dinner because you have the chance to see the play
      - Forgo the tickets and keep your dinner plans
  - question: While having dinner with a friend, I am least likely to initiate a conversation about...
    answers:
      - smartphones
      - Bollywood
      - vitamins
      - global warming
  - question: I spend more of my leisure time...
    answers:
      - playing sports
      - reading
      - watching TV or movies
      - out on the town
  - question: For someone my age, my overall health is...
    answers:
      - excellent
      - good
      - fair
      - poor
  - question: When it comes to giving time or money to charities, churches, or your community, how do you see yourself?
    answers:
      - I don't really contribute my time or money in those ways.
      - I'm average.
      - I'm an avid do-gooder.
  - question: I work hardest at pleasing my...
    answers:
      - self
      - family
      - peers
      - employer
  - question: How often do you pray?
    answers:
      - Never
      - When something unusual happens in my life
      - Daily
  - question: Of the following historical figures, whose ideology most closely matches your own?
    answers:
      - Rosa Parks
      - Winston Churchill
      - Marie Curie
      - George Orwell
  - question: Of the following historical figures, whose ideology most closely matches your own?
    answers:
      - Billie Jean King
      - Tim Berners-Lee
      - Anne Frank
      - Muhammed Ali
  - question: If 20 strangers, all of whom are about your age, were to guess your age, with no other information than your physical appearance, the majority would guess you are...
    answers:
      - younger than you are
      - older than you are
      - about the correct age
  - question: If facing a life-threatening situation and needing to act decisively, I would most likely...
    answers:
      - be very nervous and lose some self-control
      - respond pretty well
      - act with uncommon resolve and decisiveness
  - question: My outlook on life is more like that of...
    answers:
      - an optimist
      - a pessimist
      - a realist
      - a stoic
  - question: What's the value of the most expensive gift you've ever received, excluding engagement or wedding rings?
    answers:
      - $1,000 or less
      - Between $1,000 and $10,000
      - $10,000 or more
  - question: The type of attire that is most 'me' is...
    answers:
      - revealing
      - casual
      - businesswear
      - formal
  - question: When you first learned of the September 11, 2001 attacks on the World Trade Center towers in New York, which of the following reactions most closely matched your own?
    answers:
      - “Why is this happening?”
      - “Those poor people.”
      - “This is like something out of a movie.”
      - “This is the price for U.S. interference in other countries' affairs.”
